import { connect } from "react-redux";
import { fetchOverdueDocuments } from "./state/actions";
import OverdueDocumentsListComponent from "./OverdueDocumentsList";

const mapStateToProps = (state) => {
  const props = {
    data: state.statsOverdueDocuments
      ? state.statsOverdueDocuments.data
      : { hits: [], total: 0 },
    error: state.statsOverdueDocuments
      ? state.statsOverdueDocuments.error
      : null,
    isLoading: state.statsOverdueDocuments
      ? state.statsOverdueDocuments.isLoading
      : false,
  };
  return props;
};

const mapDispatchToProps = {
  fetchOverdueDocuments,
};

export const OverdueDocumentsList = connect(
  mapStateToProps,
  mapDispatchToProps
)(OverdueDocumentsListComponent);
